import { SubnetOperationConstant } from '@/common/Constants';

const SubCidrHelper = {};

/**
 * 内容默认居中显示，改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

export function SubCidrOperations(caseOps, target, param) {
  	switch (parseInt(caseOps, 10)) {
		// 删除次要CIDR操作
		case SubnetOperationConstant.DELETE:
	  	const h = target.$createElement;
	  	const token = target.clientToken
	  	const params = {
			region: param.region,
			secondaryCidrId: param.secondaryCidrId,
			clientToken: token
	  	};
	  	target.$msgbox({
			title: target.$t('subnet.text.deleteSubCidr'),
			message: h('p', getClass(), [
			  	h('span', null, target.$t('subnet.help.confirmToDeleteSubCidr', [param.name, param.cidr])),
			]),
			closeOnClickModal: false,
			showCancelButton: true,
			confirmButtonText: target.$t('popHelper.text.sure'),
			cancelButtonText: target.$t('popHelper.text.cancel'),
	  	}).then(() => {
			Ajax.del('/api/cps/secondaryCidrs', params)
			.then(() => {
				target.getServerData();
				target.getSubCidrsList();
			})
		  	.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					target.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		  	})
		  	.finally(() => {
		  	});
	  	});
  	}
}

export default SubCidrHelper;



// WEBPACK FOOTER //
// ./src/common/SubCidrHelper.js